namespace GeniuzPOS.Product {
    export interface CsSubCategory2Row {
        Id?: number;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsSubCategory2Row {
        export const idProperty = 'SubCat2Code';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsSubCategory2';
        export const lookupKey = 'Product.CsSubCategory2';

        export function getLookup(): Q.Lookup<CsSubCategory2Row> {
            return Q.getLookup<CsSubCategory2Row>('Product.CsSubCategory2');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-3:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-3:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-3:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า-3:Modify';

        export declare const enum Fields {
            Id = "Id",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
